
import {groupBy, mapValues, values, cloneDeep} from 'lodash';

export const getClonedObject = inputObject => inputObject ? cloneDeep(inputObject) : inputObject;

export const groupByMultipleProperties = (collection, keys) => {
    if (!keys.length) {
        return collection;
    }
    const first = keys[0];
    const rest = keys.slice(1);
    return mapValues(groupBy(collection, first), eachValue => {
        return {[first]: eachValue[0][first], subRows: values(groupByMultipleProperties(eachValue, rest))};
    });
};
